<script>

export default {
  name: 'NavTree',
};

</script>

<template>

  <div class="bg-grey mb-8">
    <div class="flex">
      <div class="flex-1">
        <div class="flex items-stretch h-full">
          <div class="self-center flex-1 text-white text-xl px-4 py-2 flex flex-row">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
